// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3PQrm","errorLogs":"styles_errorLogs__21Es3"};